import { Radio } from 'antd';
import React from 'react';

import './ViewModeRadio.scss';

export enum IsLegacyFilterOption {
  CURRENT = 'CURRENT',
  ALL = 'ALL',
}

type ViewModeRadioProps<T extends string> = {
  value: IsLegacyFilterOption;
  onChange: (value: T) => void;
  options: { value: T; label: string }[];
};

export const ViewModeRadio = <T extends string>({
  value,
  onChange,
  options,
}: ViewModeRadioProps<T>) => {
  return (
    <div className="view-mode-radio">
      <div className="title">View mode</div>
      <Radio.Group
        value={value}
        onChange={(e) => onChange(e.target.value as T)}
        options={options}
        optionType="default"
        className="vertical-radio"
      />
    </div>
  );
};
